import * as React from 'react';
import { VariableSizeList } from 'react-window';

import { ListBoxRow } from '@/shared/components/ui/form/components/searchable-select/components/list-box/components/list-box-row/list-box-row';
import {
  ListBoxWrapper,
  ListBoxWrapperContext,
} from '@/shared/components/ui/form/components/searchable-select/components/list-box/components/list-box-wrapper/list-box-wrapper';
import { useItemData } from '@/shared/components/ui/form/components/searchable-select/components/list-box/hooks/use-item-data/use-item-data';
import { useResetCache } from '@/shared/components/ui/form/components/searchable-select/components/list-box/hooks/use-reset-cache/use-reset-cache';
import {
  ITEM_SIZE,
  LISTBOX_PADDING,
} from '@/shared/components/ui/form/components/searchable-select/components/list-box/list-box.constants';
import { TListBoxProps } from '@/shared/components/ui/form/components/searchable-select/components/list-box/list-box.types';

export const ListboxComponent: React.FC<TListBoxProps> = ({
  ref,
  ...props
}) => {
  const { children, ...other } = props;
  const itemData: React.ReactElement[] = useItemData({
    children: children as React.ReactElement[],
  });

  const itemCount = itemData.length;

  const getHeight = () => {
    return itemData.slice(0, 7).length * ITEM_SIZE + 2 * LISTBOX_PADDING;
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <ListBoxWrapperContext value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight()}
          width="100%"
          ref={gridRef}
          outerElementType={ListBoxWrapper}
          innerElementType="ul"
          itemSize={() => ITEM_SIZE}
          overscanCount={5}
          itemCount={itemCount}
        >
          {ListBoxRow}
        </VariableSizeList>
      </ListBoxWrapperContext>
    </div>
  );
};
